import * as React from "react";
import * as ReactDOM from "react-dom";
import { InputSize } from "../input";

export const DROPDOWN_TEXT_ITEM_HEIGHT: number = 21;

interface IProperties
{
    /**
     * Der momentane Index dieses Items.
     */
    index?: number;

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties;

    /**
     * Die DataSource die an diese Komponente gebunden ist.
     */
    item?: any;

    /**
     * Enthält den tatsächlichen Wert der Komponente.
     */
    value?: any;

    /**
     * Enthält den angezeigten Wert der Komponente.
     */
    displayValue: string;

    /**
     * Enthält den angezeigten Wert der Komponente welcher Fettgedruckt sein soll.
     */
    boldDisplayValue?: string;

    /**
     * Ein Wert, der angibt ob dieses Item selektiert ist.
     */
    isSelected?: boolean;

    /**
     * Wird ausgeführt, sobald auf dieses Item geklickt wird.
     */
    onClick?: (value: any, displayValue: string, item?: any) => void;
}

export class DropDownTextItem extends React.Component<IProperties>
{
    /**
     * Initialisiert die Komponente @see DropDownTextItem.
     * @param props Die Eigenschaften dieser Komponente.
     */
    constructor(props: IProperties)
    {
        super(props);
        
        this.state = {
            value: (props.value != null) ? props.value : props.displayValue
        };
    }

    /**
     * Wenn auf dieses Item geklickt wird, wird die onClick Eigenschaft ausgeführt (falls übergeben).
     */
    private onClick()
    {
        if (this.props.onClick != null)
            this.props.onClick(this.props.value, this.props.displayValue, this.props.item);
    }

    /**
     * Rendert den Anzeigetext.
     */
    private getDisplayValue()
    {
        if (this.props.boldDisplayValue != null && this.props.displayValue !== this.props.boldDisplayValue)
        {
            var parts = this.props.displayValue.split(new RegExp(`(${this.props.boldDisplayValue})`, 'gi'));
            return <span>{parts.map(part => part.toLowerCase() === this.props.boldDisplayValue.toLowerCase() ? <b>{part}</b> : part)}</span>;
        }
        else
        {
            return this.props.displayValue;
        }
    }

    /**
     * Rendert die Komponente.
     */
    render()
    {
        var className: string[] = ["dropdown-textitem"]

        if (this.props.isSelected)
            className.push("dropdown-textitem--selected");

        return (
            <div
                className={className.join(" ")}
                style={this.props.style}
                onClick={this.onClick.bind(this)}>
                {this.getDisplayValue()}
            </div>
        );
    }
}